import { render, staticRenderFns } from "./OrderDetailCooperates.vue?vue&type=template&id=aeeff590&scoped=true&"
import script from "./OrderDetailCooperates.vue?vue&type=script&lang=js&"
export * from "./OrderDetailCooperates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeeff590",
  null
  
)

export default component.exports